export default __webpack_public_path__ + "7a0c130deb250279eef69bfcc0cadc9c.svg";